export default __webpack_public_path__ + "static/media/50061505_575246.682e8303.png";